import styles from './AnimatedHamburger.module.scss'

type Props = {
  barStyles?: string
  className?: string
  open: boolean
}

const AnimatedHamburger = ({ barStyles = '', className = '', open }: Props) => (
  <div className={`${styles.container} ${open ? styles.change : ''} ${className}`}>
    <div className={`${styles.bar1} ${barStyles}`}></div>
    <div className={`${styles.bar2} ${barStyles}`}></div>
    <div className={`${styles.bar3} ${barStyles}`}></div>
  </div>
)

export default AnimatedHamburger
